import { TCatalog_identifier } from "~/model/Instances/TCatalog";

export const handleRowClick_Document =
  (history, isClickOnSubCatalog) => (item: unknown) => {
    if (isClickOnSubCatalog) {
      history.push(
        `/documents/documents_in_catalog/${(item as TCatalog_identifier).id}`
      );
    } else {
      history.push(
        `/documents/sub_catalogs/${(item as TCatalog_identifier).id}`
      );
    }
  };
